export default "__VITE_ASSET__tBNs_4VC__"